<template>
  <div>
    <el-table :cell-style='styleCenter' :data="attractList" :header-cell-style='styleCenter' style="width: 100%">
      <el-table-column label="标的类型" prop="type" width="120">
        <template slot-scope="scope">
          {{ formatDataType(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column label="标的名称" prop="title" width="140"></el-table-column>
      <el-table-column label="价格" prop="price" width="120">
        <template slot-scope="scope">
          {{ scope.row.price }}{{ scope.row.priceUnit }}
        </template>
      </el-table-column>
      <el-table-column label="有效时间" prop="endTime" width="120">
        <template slot-scope="scope">
          {{ scope.row.endTime.slice(0, 10) }}
        </template>
      </el-table-column>
      <el-table-column label="所在地" prop="publishArea" width="140"></el-table-column>
      <el-table-column label="审核状态" prop="publishStatus" width="160">
        <template slot-scope="scope">
          {{ scope.row.publishStatus == 1 ? '已提交' : (scope.row.publishStatus == 2 ? '已发布' : '已驳回') }}
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="publishStatus" width="160">
        <template slot-scope="scope">
          <el-button v-if="scope.row.publishStatus==2" type="text" @click="openDetail(scope.row,1)">查看供应</el-button>
          <el-button v-if="scope.row.publishStatus==2" type="text" @click="openDetail(scope.row,2)">查看站内信
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="bottom-page-div">
      <el-pagination :current-page="page.currentPage" :page-size="page.pageSize"
                     :page-sizes="[10, 20, 30, 50]"
                     :total="page.total" layout="total, sizes, prev, pager, next, jumper"
                     @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <el-dialog v-if="dialogVisible" :visible.sync="dialogVisible" title="查看">
      <div>
        <el-table :data="showData" style="width: 100%">
          <el-table-column label="姓名" prop="sendName" width="180"></el-table-column>
          <el-table-column label="电话" prop="phone" width="180"></el-table-column>
          <el-table-column label="内容" prop="content" width="400"></el-table-column>
        </el-table>
        <el-pagination :current-page="dialogPage.currentPage" :page-size="dialogPage.pageSize"
                       :page-sizes="[10, 20, 30, 50]"
                       :total="dialogPage.total" layout="total, sizes, prev, pager, next, jumper"
                       @size-change="dialogHandleSizeChange" @current-change="dialogHandleCurrentChange">
        </el-pagination>
      </div>
      <el-button @click="dialogVisible=false">关闭</el-button>
    </el-dialog>
  </div>
</template>

<script>
import {cmsMyList} from "@/api/biz/columnBulletin/attractInvestment";
import {mapGetters} from "vuex";
import {getBizDictByCode} from '@/api/system/dict'
import {getCmsList} from '@/api/biz/columnBulletin/attractMeet'

export default {

  name: 'attractInvestmentManagerView',
  data() {
    return {
      attractList: [],
      styleCenter: {'text-align': 'center'},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      dialogPage: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      dialogVisible: false,
      showType: 1,
      rowData: {},
      showData: [],
    }
  },
  computed: {...mapGetters(["userInfo"])},
  created() {
    this.getDict();
    this.queryData();
  },
  methods: {
    dialogHandleSizeChange(val) {
      this.dialogPage.pageSize = val;
      this.queryDialogData();
    },
    dialogHandleCurrentChange(val) {
      this.dialogPage.currentPage = val;
      this.queryDialogData();
    },
    queryDialogData() {
      let page = this.dialogPage;
      getCmsList(page.currentPage, page.pageSize, {baiId: this.rowData.id, type: this.showType}).then(res => {
        const data = res.data.data;
        this.showData = data.records;
        this.dialogPage.total = data.total;
      })
    },
    openDetail(row, type) {
      this.showType = type;
      this.rowData = row;
      let page = this.dialogPage;
      getCmsList(page.currentPage, page.pageSize, {baiId: row.id, type: type}).then(res => {
        const data = res.data.data;
        this.showData = data.records;
        this.dialogPage.total = data.total;
        if (data.total > 0) {
          this.dialogVisible = true;
        } else {
          return this.$message({type: 'warning', message: '未查询到数据'})
        }
      })
    },
    getDict() {
      getBizDictByCode('bulletin_type').then(res => {
        this.bulletinTypeDict = res.data.data;
      });
    },
    formatDataType(type) {
      let data = '';
      this.bulletinTypeDict.forEach(ele => {
        if (ele.dictKey == type) data = ele.dictValue;
      })
      return data;
    },
    queryData() {
      let page = this.page;
      cmsMyList(page.currentPage, page.pageSize, {createUser: this.userInfo.user_id}).then(res => {
        const data = res.data.data;
        this.attractList = data.records;
        this.page.total = data.total;
      })
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.queryData(this.page);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.queryData(this.page);
    },

  }
}
</script>

<style>

</style>
